/**
 * 拼前端静态资源地址，兼容 publicPath=/ui/（build:api）与 /（正式独立站）。
 * 创建于 2026-08-12
 * @param {string} path 相对路径，如 static/atten/index.html 或 /static/atten/index.html
 * @returns {string}
 */
export function publicAssetUrl(path) {
  const base = process.env.BASE_URL || "/";
  const normalized = String(path || "").replace(/^\/+/, "");
  return `${base}${normalized}`;
}
